// extracted by mini-css-extract-plugin
module.exports = {"videoOverlay":"i_N","safeArea":"i_O","videoContainer":"i_P","videoClose":"i_Q","videoCloseIcon":"i_R"};